export class DeactivateLobbyEntries {
  lobbyEntryIds: number[];
  deactivateReason: string;
  public constructor(lobbyEntryIds: number[], deactivateReason: string) {
    this.lobbyEntryIds = lobbyEntryIds;
    this.deactivateReason = deactivateReason;
  }
}
